import axios from "axios";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

const _RevenueView: React.FC = () => {
  const [revenueCount, setRevenueCount] = useState<number | undefined>(
    undefined
  );
  const { id } = useParams();

  const fetchRevenue = () => {
    const obj = { id: id } as { id: string };
    axios
      .get(
        `https://wallof-backend.uc.r.appspot.com/accounting/revenue/${obj.id}`
      )
      .then((r) => {
        console.log(r);
        const val = r.data as unknown as any;
        if (val) {
          console.log(val);
          setRevenueCount(val["revenue"][0]["Revenue"] as number);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  useEffect(() => {
    if (revenueCount === undefined) fetchRevenue();
  }, [revenueCount]);

  if (revenueCount === undefined) return <h1>Loading...</h1>;
  return <h1>ZAR {revenueCount}</h1>;
};

const RevenueView = observer(_RevenueView);
export default RevenueView;
